/* Fills the selected menu schedule name into the Claude prompt so users don't have to
   edit "menu_schedule_name" by hand. Works alongside copy-to-clipboard: it keeps the
   prompt's <pre> and the copy button's value in sync with the dropdown selection.

HTML Example:
<div data-controller="prompt-builder" data-prompt-builder-template-value="...%%SCHEDULE%%...">
  <select data-prompt-builder-target="schedule" data-action="change->prompt-builder#update"></select>
  <i data-prompt-builder-target="copyValue" data-copy-to-clipboard-value="..."></i>
  <pre data-prompt-builder-target="output"></pre>
</div>
*/

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['schedule', 'output', 'copyValue']
  static values = { template: String }

  connect() {
    this.update()
  }

  update() {
    const name = this.hasScheduleTarget ? this.scheduleTarget.value : ''
    const replacement = name ? JSON.stringify(name) : 'null'
    // Function replacer inserts `replacement` literally (no `$` special-casing).
    const text = this.templateValue.replace('%%SCHEDULE%%', () => replacement)

    if (this.hasOutputTarget) {
      this.outputTarget.textContent = text
    }
    if (this.hasCopyValueTarget) {
      this.copyValueTarget.setAttribute('data-copy-to-clipboard-value', text)
    }
  }
}
